import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var WineIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48",
    height: "48"
  }, props), React.createElement("g", {
    className: styles["nc-icon-wrapper"] || "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    fill: "none"
  }, React.createElement("path", {
    "data-cap": "butt",
    "data-color": "color-2",
    d: "M10.143 14h27.714"
  }), React.createElement("path", {
    d: "M24 30c-8.106 0-14.509-6.877-13.931-14.962L11 2h26l.931 13.038C38.509 23.123 32.106 30 24 30zM24 30v16M14 46h20"
  })));
});

export default WineIcon;
//# sourceMappingURL=wine.svg.js.map
